module.exports = "/fonts/vendor/cryptocoins-icons/webcryptocoins.woff2?b458578cb4918359c291f21ade2806a8";